<template>
<div class="dashbord-wrp">
  <div class="wrp">
    <h1 class="pc-title">Weekly Labour</h1> 
    <div class="clear mar-btm-20">
        <div class='back_box' @click="back()">
            <i class="el-icon-back"></i> Back
        </div>
        <div class="chartSelect2">
          <el-select v-model="curVal" placeholder=" " @change="detectOption">
            <el-option
              class="revenue-labour-option"
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
    </div>
    <div class="black-bgd-color">
        <WeeklyEchart :current="curVal" :datum="chartData" :weekStart="weekStart" :showDeputyCycle="showDeputyCycle" />
    </div>
    <LabourTable :loading="loading"
      :list="actualsLabourList"
      :showDeputyCycle="showDeputyCycle"
      :weekStart="weekStart"
      :title="'Actuals Labour'" />
    <LabourTable :loading="loading"
      :list="budgetedLabourList"
      :showDeputyCycle="showDeputyCycle"
      :weekStart="weekStart"
      :title="'Rostered Labour'" />
  </div>
</div>
</template>

<script>
import Api from "../../api/api";
import api from "../../api/dashboard";
import weeklyEchart from "./component/weeklyEchart.vue";
import labourTable from "./component/labourTable.vue";
import axios from "axios";
import { env } from "../../env";
const CancelToken = axios.CancelToken;

export default {
  name: "headcon",
  // inject: ["reload", "hidden"],
  props: {
    week: null,
  },
  data() {
    return {
        curVal:"Cost",//下拉选择初始值 
        options:[//下拉选择数据
            {value: 'Cost',label: 'Cost'},
            {value: 'Hour',label: 'Hour'}
        ],
        curDay:1,//当前选中的日期
        loading: false,
        source: CancelToken.source(),
        optionsWeek: [],

        weekStart: 0,
        showDeputyCycle: false,

        chartData: {
          actualWeekDayProportionPojo_cost: null,
          actualWeekDayProportionPojo_time: null,
          targetWeekDayProportionPojo_cost: null,
          targetWeekDayProportionPojo_time: null
        },
        actualsLabourList: [],
        budgetedLabourList: [],
        weekDayName: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'],

        dashBoardId: null
    };
  },
  components: {WeeklyEchart: weeklyEchart, LabourTable: labourTable},
  methods: {
    detectOption() {
      if (!this.dashBoardId)
        return

      let temp = JSON.parse(JSON.stringify(this.chartData))
      temp.current = (new Date()).getTime()
      this.chartData = {}
      this.actualsLabourList = []
      this.budgetedLabourList = []

      this.prepareDatam(this.dashBoardId)
    },
    back() {
      this.$router.replace('/dashboard')
    },


    getActualRosteredLabourList(type='hour', res) {
      let actualList = []
      let targetList = []
      let chartData =  {
        actualWeekDayProportionPojo_cost: {},
        actualWeekDayProportionPojo_time: {},
        targetWeekDayProportionPojo_cost: {},
        targetWeekDayProportionPojo_time: {}
      }

      res.actualLabourByEmployee.forEach(item => {
        actualList.push({
          type: type,
          left: item.employeeName,
          ...Object.fromEntries(this.weekDayName.map(day => [
            day, 
            item.labourCostByDay[day] ? item.labourCostByDay[day][type === 'hour' ? 'hours' : 'amount'] : null
          ])),
          total: item.labourCostTotal ? item.labourCostTotal[type === 'hour' ? 'hours' : 'amount'] : null
        })
      })

      res.rosteredLabourByEmployee.forEach(item => {
        targetList.push({
          type: type,
          left: item.employeeName,
          ...Object.fromEntries(this.weekDayName.map(day => [
            day, 
            item.labourCostByDay[day] ? item.labourCostByDay[day][type === 'hour' ? 'hours' : 'amount'] : null
          ])),
          total: item.labourCostTotal ? item.labourCostTotal[type === 'hour' ? 'hours' : 'amount'] : null
        })
      })

      this.budgetedLabourList = [
        { 
          type: type, 
          left: type === 'hour' ? 'Total Hours' : 'Total Cost', 
          ...Object.fromEntries(this.weekDayName.map(day => {
            chartData[`targetWeekDayProportionPojo_${type === 'hour' ? 'time' : 'cost'}`][day] = res.rosteredLabourByDay[day] ? res.rosteredLabourByDay[day][type === 'hour' ? 'hours' : 'amount'] : null
            
            return [
              day, 
              res.rosteredLabourByDay[day] ? res.rosteredLabourByDay[day][type === 'hour' ? 'hours' : 'amount'] : null
            ]
          })),
          total: res.rosteredLabourByDayTotal ? res.rosteredLabourByDayTotal[type === 'hour' ? 'hours' : 'amount'] : null,
          shrink: false,
          list: targetList
        }
      ]

      this.actualsLabourList = [
        { 
          type: type, 
          left: type === 'hour' ? 'Total Hours' : 'Total Cost', 
          ...Object.fromEntries(this.weekDayName.map(day => {
            chartData[`actualWeekDayProportionPojo_${type === 'hour' ? 'time' : 'cost'}`][day] = res.actualLabourByDay[day] ? res.actualLabourByDay[day][type === 'hour' ? 'hours' : 'amount'] : null
            return [
              day, 
              res.actualLabourByDay[day] ? res.actualLabourByDay[day][type === 'hour' ? 'hours' : 'amount'] : null
            ]
          })),
          total: res.actualLabourByDayTotal ? res.actualLabourByDayTotal[type === 'hour' ? 'hours' : 'amount'] : null,
          shrink: false,
          list: actualList
        }
      ]

      this.chartData =  chartData;
    },

    async getDashboardDetailedWeeklyV2(startDate) {
      const res = await api.getDashboardDetailedWeeklyV2(startDate)

      if (res) {
        this.getActualRosteredLabourList(this.curVal === 'Hour' ? 'hour' : 'cost', res)
      }

    },

    fetchDashboardLabourData(val) {
      let current = this.optionsWeek.find((item) => {
        return item.dashBoardId === val;
      });

      const isDashboardV2 = sessionStorage.getItem('isDashboardV2')

      if (isDashboardV2 == 'true' && env.NAME !== 'lucas') {
        // v2 process
        this.getDashboardDetailedWeeklyV2(current.startDate)
      } else {
          // v1 process
        let request_params = {
          dashBoardId: val,
          monDateTime: current.monDateTime,
          sunDateTime: current.sunDateTime
        }

        this.requestNow(request_params)
      }
    },
    
    prepareDatam(val) {
      this.loading = true
      this.dashBoardId = val

      if (this.optionsWeek.length === 0) {

        Api.getTimeList((res) => {
          if (!res || !res.data) return;
          if (res.data.code == 0) {
            this.isShowDeputyCycleChecked = res.data.data.syncWeekStartWithDeputy;
            this.weekStart = res.data.data.syncWeekStartWithDeputy ? res.data.data.weekStart : 1
            this.showDeputyCycle = res.data.data.weekStart !== 1 && res.data.data.syncWeekStartWithDeputy ? true : false;

            this.optionsWeek = res.data.data.list

            this.fetchDashboardLabourData(val)

          } else if (res.data.code == 8902) {
            sessionStorage.clear();
            this.$router.push("/login");
          } else {
            Utils.alert("", res.data.message, "error");
          }
        });
      } else {
         this.fetchDashboardLabourData(val)
      }

      this.loading = false
    },
    requestNow(params) {
      api.labourApi({
        params: params,
        cancelToken: this.source.token,
        callback: this.callback,
      });
    },
    callback(res) {
      var that = this;
      if (res.data.code == 0) {
        let data = res.data.data
        that.chartData = data
        that.loading = false
        if (this.curVal === 'Hour') {
            let actualList = []
            data.actualLabourHoursList.forEach(i => {
              actualList.push({ type: this.curVal === 'Cost' ? 'cost' : 'hour', left: i.employee, mon: i.mon, tue: i.tue, wed: i.wed, thu: i.thu, fri: i.fri, sat: i.sat, sun: i.sun, total: i.total })
            })
            if (data.actualLabourHoursListTotal)
              that.actualsLabourList = [{ type: this.curVal === 'Cost' ? 'cost' : 'hour', left: this.curVal === 'Cost' ? 'Total Cost' : 'Total Hours', mon: data.actualLabourHoursListTotal ? data.actualLabourHoursListTotal.mon : null, tue: data.actualLabourHoursListTotal ? data.actualLabourHoursListTotal.tue : null, wed: data.actualLabourHoursListTotal ? data.actualLabourHoursListTotal.wed : null, thu: data.actualLabourHoursListTotal ? data.actualLabourHoursListTotal.thu : null, fri: data.actualLabourHoursListTotal ? data.actualLabourHoursListTotal.fri : null, sat: data.actualLabourHoursListTotal ? data.actualLabourHoursListTotal.sat : null, sun: data.actualLabourHoursListTotal ? data.actualLabourHoursListTotal.sun : null, total: data.actualLabourHoursListTotal ? data.actualLabourHoursListTotal.total : null, shrink: false, list: actualList }]
            else
              that.actualsLabourList = []
            
            let targetList = []
            data.targetLabourHoursList.forEach(i => {
              targetList.push({ type: this.curVal === 'Cost' ? 'cost' : 'hour', left: i.employee, mon: i.mon, tue: i.tue, wed: i.wed, thu: i.thu, fri: i.fri, sat: i.sat, sun: i.sun, total: i.total })
            })
            if (data.targetLabourHoursListTotal)
              that.budgetedLabourList = [{ type: this.curVal === 'Cost' ? 'cost' : 'hour', left: this.curVal === 'Cost' ? 'Total Cost' : 'Total Hours', mon: data.targetLabourHoursListTotal ? data.targetLabourHoursListTotal.mon : null, tue: data.targetLabourHoursListTotal ? data.targetLabourHoursListTotal.tue : null, wed: data.targetLabourHoursListTotal ? data.targetLabourHoursListTotal.wed : null, thu: data.targetLabourHoursListTotal ? data.targetLabourHoursListTotal.thu : null, fri: data.targetLabourHoursListTotal ? data.targetLabourHoursListTotal.fri : null, sat: data.targetLabourHoursListTotal ? data.targetLabourHoursListTotal.sat : null, sun: data.targetLabourHoursListTotal ? data.targetLabourHoursListTotal.sun : null, total: data.targetLabourHoursListTotal ? data.targetLabourHoursListTotal.total : null, shrink: false, list: targetList }]
            else
              that.budgetedLabourList = []
        } else {
          // console.log('wurweiutiuewtuiweuitui')
          let actualList = []
          data.actualLabourList.forEach(i => {
            actualList.push({ type: this.curVal === 'Cost' ? 'cost' : 'hour', left: i.employee, mon: i.mon, tue: i.tue, wed: i.wed, thu: i.thu, fri: i.fri, sat: i.sat, sun: i.sun, total: i.total })
          })
          if (data.actualLabourListTotal)
            that.actualsLabourList = [{ type: this.curVal === 'Cost' ? 'cost' : 'hour', left: this.curVal === 'Cost' ? 'Total Cost' : 'Total Hours', mon: data.actualLabourListTotal ? data.actualLabourListTotal.mon : null, tue: data.actualLabourListTotal ? data.actualLabourListTotal.tue : null, wed: data.actualLabourListTotal ? data.actualLabourListTotal.wed : null, thu: data.actualLabourListTotal ? data.actualLabourListTotal.thu : null, fri: data.actualLabourListTotal ? data.actualLabourListTotal.fri : null, sat: data.actualLabourListTotal ? data.actualLabourListTotal.sat : null, sun: data.actualLabourListTotal ? data.actualLabourListTotal.sun : null, total: data.actualLabourListTotal ? data.actualLabourListTotal.total : null, shrink: false, list: actualList }]
          else
            that.actualsLabourList = []
          let targetList = []
          data.targetLabourList.forEach(i => {
            targetList.push({ type: this.curVal === 'Cost' ? 'cost' : 'hour', left: i.employee, mon: i.mon, tue: i.tue, wed: i.wed, thu: i.thu, fri: i.fri, sat: i.sat, sun: i.sun, total: i.total })
          })
          if (data.targetLabourListTotal)
            that.budgetedLabourList = [{ type: this.curVal === 'Cost' ? 'cost' : 'hour', left: this.curVal === 'Cost' ? 'Total Cost' : 'Total Hours', mon: data.targetLabourListTotal ? data.targetLabourListTotal.mon : null, tue: data.targetLabourListTotal ? data.targetLabourListTotal.tue : null, wed: data.targetLabourListTotal ? data.targetLabourListTotal.wed : null, thu: data.targetLabourListTotal ? data.targetLabourListTotal.thu : null, fri: data.targetLabourListTotal ? data.targetLabourListTotal.fri : null, sat: data.targetLabourListTotal ? data.targetLabourListTotal.sat : null, sun: data.targetLabourListTotal ? data.targetLabourListTotal.sun : null, total: data.targetLabourListTotal ? data.targetLabourListTotal.total : null, shrink: false, list: targetList }]
          else
            that.budgetedLabourList = []
        }
  
      } else if (res.data.code == 8902) {
        sessionStorage.clear();
        this.$router.push("/login");
      } else {
        Utils.alert("", res.data.message, "error");
      }
    },

    getWeeklyData(val) {
      var that = this
        // console.log('val')
      if (!val)
        return
      if (val === -1 || val === -2 || val === -3) {
        that.loading = false;
        return;
      }
      // 如果正在刷新
      if (this.loading) {
        this.source.cancel("Operationcanceled");
        this.source = null;
        this.source = CancelToken.source();
      }
      that.prepareDatam(val)
    }
  },
  watch: {
    week: {
      deep: true,
      handler: function (val) {
        this.getWeeklyData(val)
      },
    }
  },
  created() {
    if (this.week) {
        this.getWeeklyData(this.week)
    }
  }
};
</script>
<style lang="scss" src="@/assets/css/dashborad.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/dashboard/weeklyLabour.vue